import type { BackendUser } from "./adminUsers";

export interface SFTPPublicKey {
  id: number;
  public_key: string;
  created_at: string;
}

export type SFTPAuthMode = "password" | "key" | "both";

/** Prefer API `auth_mode`; fall back to stored credentials shape for older responses. */
export function resolveSftpAuthMode(c: {
  auth_mode?: SFTPAuthMode | string;
  has_password: boolean;
  has_keys: boolean;
}): SFTPAuthMode {
  const m = c.auth_mode;
  if (m === "password" || m === "key" || m === "both") return m;
  if (c.has_password && c.has_keys) return "both";
  if (c.has_keys) return "key";
  return "password";
}

/** Client-side table sort fields (SFTP list is loaded in full; sort is applied in the UI). */
export type SFTPConnectionSortBy =
  | "name"
  | "client_name"
  | "bucket_folder"
  | "created_at";

export interface SFTPConnection {
  id: number;
  user_id: number | null;
  /** Backend (auth) user display: first_name or username; null if unlinked. */
  client_name?: string | null;
  /** Full row for Autocomplete when the linked user is not in the first page of the users list. */
  backend_user?: BackendUser | null;
  name: string;
  server_id: string;
  username: string;
  bucket: string;
  folder: string;
  role: string;
  subfolders: string[];
  is_active: boolean;
  auth_mode?: SFTPAuthMode;
  public_keys: SFTPPublicKey[];
  has_password: boolean;
  has_keys: boolean;
  created_at: string;
  updated_at: string;
}

export interface SFTPConnectionsResponse {
  connections: SFTPConnection[];
}

export interface SFTPConnectionCreatePayload {
  user_id?: number | null;
  name?: string;
  server_id: string;
  username: string;
  password?: string;
  bucket?: string;
  folder?: string;
  role?: string;
  subfolders?: string[];
  is_active?: boolean;
  auth_mode?: SFTPAuthMode;
  public_keys?: string[];
}

export type SFTPConnectionUpdatePayload = Partial<SFTPConnectionCreatePayload> & { id: number };
